import { render, staticRenderFns } from "./ModalPurchasesByProvider.vue?vue&type=template&id=56980ea0"
import script from "./ModalPurchasesByProvider.vue?vue&type=script&lang=js"
export * from "./ModalPurchasesByProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports